var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconComponent_1;
import { css } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement, property } from 'lit/decorators.js';
import { Icon } from '../../utils/icon-utils.js';
let IconComponent = class IconComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.icon = 'utility:apps';
        this.size = IconComponent_1.SMALL;
        this._hasClickListener = false;
    }
    static { IconComponent_1 = this; }
    static { this.XXSMALL = 'xxsmall'; }
    static { this.XSMALL = 'xsmall'; }
    static { this.SMALL = 'small'; }
    static { this.MEDIUM = 'medium'; }
    static { this.LARGE = 'large'; }
    static get styles() {
        return [
            ...super.styles,
            css `
        // put css styles here
        .slds-icon.clickable {
          cursor: pointer;
          padding: 0.2rem;
        }
        .slds-icon.clickable:hover {
          border-radius: 2rem;
          background-color: var(--slds-c-button__icon-background-color);
          background: #00000010;
          padding: 0.1rem;
        }
      `,
        ];
    }
    render() {
        const split = this.icon.split(':');
        let _icon = split[split.length - 1];
        let _sprite = split.length > 1 ? split[0] : 'utility';
        let classes = ['slds-icon', 'slds-icon-text-default'];
        switch (this.size) {
            case IconComponent_1.XXSMALL:
                classes.push('slds-icon_xx-small');
                break;
            case IconComponent_1.XSMALL:
                classes.push('slds-icon_x-small');
                break;
            case IconComponent_1.SMALL:
                classes.push('slds-icon_small');
                break;
            case IconComponent_1.MEDIUM:
                classes.push('slds-icon_medium');
                break;
            case IconComponent_1.LARGE:
                classes.push('slds-icon_large');
                break;
        }
        return Icon.getSVGIconTag({ icon: _icon, sprite: _sprite, classes: [...classes, this._hasClickListener ? 'clickable' : ''], color: this.color });
    }
    addEventListener(type, listener, options) {
        super.addEventListener(type, listener, options);
        if (type === 'click' && !this._hasClickListener) {
            this.style.cursor = 'pointer';
            this._hasClickListener = true;
        }
    }
    removeEventListener(type, listener, options) {
        super.removeEventListener(type, listener, options);
        if (type === 'click') {
            this._hasClickListener = false;
            this.style.cursor = '';
        }
    }
};
__decorate([
    property({ type: String })
], IconComponent.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], IconComponent.prototype, "size", void 0);
__decorate([
    property({ type: String })
], IconComponent.prototype, "color", void 0);
IconComponent = IconComponent_1 = __decorate([
    customElement('ggo-icon')
], IconComponent);
export { IconComponent };
